import React from "react";
import StaffDocumentsChart from "./staff-document-chart";
import ClientDocumentsChart from "./client-most-document-chart";
import BillingDocumentsPieChart from "./billing-status-metrics-chart";
import DocumentByPayer from "./documents-by-payer";
import DocumentByStatus from "./documents-by-status";
import DocumentByTemplate from "./documents-by-template";
import DocumentsByServiceCode from "./documents-by-service-Code";
import DocumentsBySite from "./documents-by-site";

const DocumentListChart = () => {
  return (
    <>
      {/* <div className='col-md-12 my-3 p-0'> */}
      <div className="d-flex flex-wrap gap2 reportListheader">
        <div className="col-lg-4 col-md-6 col-12">
          <StaffDocumentsChart />
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <BillingDocumentsPieChart />
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <ClientDocumentsChart />
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <DocumentByPayer />
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <DocumentByStatus />
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <DocumentByTemplate />
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <DocumentsByServiceCode />
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <DocumentsBySite />
        </div>
      </div>
    </>
  );
};

export default DocumentListChart;
